import React from 'react';
import logo from '../../assets/images/logo.jpg';
import appStoreBadge from '../../assets/images/app-store-badge.svg';
import googlePlayBadge from '../../assets/images/GooglePlay-store-badge.svg';
import './DownloadCTA.css';
import { trackButtonClick } from '../../utils/analytics';

const DownloadCTA: React.FC = () => {
  const handleAppStoreClick = () => {
    trackButtonClick('app_store', 'download_cta', 'download_click');
  };

  const handleGooglePlayClick = () => {
    trackButtonClick('google_play', 'download_cta', 'download_click');
  };

  return (
    <section className="download-section">
      <div className="download-container">
        <div className="download-content">
          <h2 className="download-heading">Get Gelwel Today</h2>
          <p className="download-subheading">
            Available on iOS & Android. Start connecting with your vibe now.
          </p>
          <div className="download-buttons">
            <div className="download-badge-container-appstore">
              <a href="#download" className="download-badge-link" onClick={handleAppStoreClick}>
                <img
                  src={appStoreBadge}
                  alt="Download on the App Store"
                  className="download-badge-appstore"
                />
              </a>
            </div>
            <div className="download-badge-container-playstore">
              <a href="#download" className="download-badge-link" onClick={handleGooglePlayClick}>
                <img
                  src={googlePlayBadge}
                  alt="Get it on Google Play"
                  className="download-badge-playstore"
                />
              </a>
            </div>
          </div>
        </div>
        <div className="download-visual">
          <div className="download-circle download-circle-1"></div>
          <div className="download-circle download-circle-2"></div>
          <div className="download-logo">
            <img
              src={logo}
              alt="Gelwel"
              className="download-logo-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default DownloadCTA;
